import * as React from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
const Wrapper = styled.div(
  ({ theme }) => css`
    margin-bottom: ${theme.spacings.md};
    overflow: auto;
  `
);
const StyledDefList = styled.dl.attrs({ className: "deflist" })(
  ({ theme }) => css`
    &&.deflist {
      dd {
        padding-left: ${theme.spacings.md};
        display: table-cell;
      }
    }
  `
);
const GlobalProcessingView = ({ gracePeriod }) => {
  const { t } = useTranslation("configurations");
  return /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement("h2", null, t("message_processors.global_title")), /* @__PURE__ */ React.createElement("p", null, t("message_processors.global_description")), /* @__PURE__ */ React.createElement(StyledDefList, null, /* @__PURE__ */ React.createElement("dt", null, t("message_processors.future_timestamp_normalization"), ":"), /* @__PURE__ */ React.createElement("dd", null, gracePeriod ? t("markdown.enabled") : t("markdown.disabled")), /* @__PURE__ */ React.createElement("dt", null, t("message_processors.grace_period"), ":"), /* @__PURE__ */ React.createElement("dd", null, gracePeriod)));
};
export default GlobalProcessingView;
